import { apiService } from './api-service';

export interface CurrentUser {
  id: string;
  username: string;
  email: string;
  full_name: string;
  role: string;
  role_name: string;
  two_factor_enabled: boolean;
  created_at: number;
}

export interface UpdateProfileData {
  full_name?: string;
  email?: string;
}

export class ProfileService {
  /**
   * Get current user profile
   */
  static async getCurrentUser(): Promise<CurrentUser> {
    const response = await apiService.get('/users/me');
    if (!response.ok) {
      throw new Error(`Failed to fetch user data: ${response.statusText}`);
    }
    const userData = await response.json();
    // Debug code to log user data
    // console.log('ProfileService.getCurrentUser() response:', userData);
    return userData;
  }

  /**
   * Update current user profile
   */
  static async updateCurrentUser(data: UpdateProfileData): Promise<CurrentUser> {
    const response = await apiService.patch('/users/me', data);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to update profile: ${response.statusText}`);
    }
    return response.json();
  }
}
